import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Sparkles, BadgePercent } from "lucide-react";

export default function ServiceCatalog({ role }) {
  const [services, setServices] = useState([]);

  useEffect(() => {
    api.get("/services").then((r) => setServices(r.data));
  }, []);

  return (
    <div className="velo-card p-6 lg:p-8">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-xl text-white font-medium">Service catalogue</h2>
          <p className="text-xs text-slate-500 mt-1 uppercase tracking-wider">Discounts + reward points per booking</p>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {services.map((s, i) => {
          const hasPrice = s.price !== null && s.price !== undefined && Number(s.price) > 0;
          const hasDiscount = Number(s.discount_amount) > 0;
          const legacy = Number(s.points_value ?? 0);
          const points = role === "affiliate"
            ? Number(s.affiliate_points ?? legacy)
            : Number(s.customer_points ?? legacy);
          return (
            <div key={s.id} data-testid={`service-${i}`} className="velo-surface rounded-lg overflow-hidden hover:border-white/20 transition-colors fade-up" style={{ animationDelay: `${i*40}ms` }}>
              {s.image_url ? <img src={s.image_url} alt="" className="w-full h-32 object-cover opacity-80" /> : null}
              <div className="p-5">
                <div className="flex items-start justify-between gap-3">
                  <div className="text-white font-medium leading-tight">{s.name}</div>
                  {hasDiscount ? (
                    <div className="shrink-0 flex items-center gap-1 text-xs text-emerald-400 font-mono">
                      <BadgePercent className="w-3 h-3" strokeWidth={2} />₹{Number(s.discount_amount).toLocaleString("en-IN")} off
                    </div>
                  ) : null}
                </div>
                <p className="text-xs text-slate-400 mt-2 leading-relaxed">{s.description}</p>
                <div className="mt-4 flex items-center justify-between pt-4 border-t border-white/5 gap-2 flex-wrap">
                  <div className="text-xs text-slate-500">
                    {hasPrice ? <span className="text-slate-300 font-mono">₹{Number(s.price).toLocaleString("en-IN")}</span> : <span className="italic">Price on request</span>}
                  </div>
                  <div className="flex items-center gap-1.5 text-pink-400 font-mono text-sm">
                    <Sparkles className="w-3.5 h-3.5" strokeWidth={2} />
                    {points} pts
                  </div>
                </div>
              </div>
            </div>
          );
        })}
        {services.length === 0 ? <div className="text-slate-500 col-span-2 text-center py-8">No services yet</div> : null}
      </div>
    </div>
  );
}
